<script setup>
import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import Breadcrumbs from "../Breadcrumbs.vue";
import api from "@/api/axios";


const store = useStore();
const isRTL = computed(() => store.state.isRTL);

const route = useRoute();
const router = useRouter();

const currentRouteName = computed(() => {
  return route.name;
});
const currentDirectory = computed(() => {
  let dir = route.path.split("/")[1];
  return dir.charAt(0).toUpperCase() + dir.slice(1);
});

// const minimizeSidebar = () => store.commit("sidebarMinimize");
const minimizeSidebar = () => {
  console.log("click");
  store.commit("sidebarMinimize");
};

const notificaciones = ref([]);
const showNotificaciones = ref(false);

const noLeidas = computed(() => notificaciones.value.filter(n => !n.readAt).length);

const formatFechaNoti = (fecha) => new Date(fecha).toLocaleString("es-CO", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

const cargarNotificaciones = async () => {
  try {
    const res = await api.get("/notifications");
    notificaciones.value = res.data.notifications;
  } catch (err) {
    // Silencioso: la campana no debe romper el resto del navbar si falla.
  }
};

const toggleNotificaciones = () => {
  showNotificaciones.value = !showNotificaciones.value;
  if (showNotificaciones.value) cargarNotificaciones();
};

const abrirNotificacion = async (notificacion) => {
  if (!notificacion.readAt) {
    await api.patch(`/notifications/${notificacion.id}/read`);
    notificacion.readAt = new Date().toISOString();
  }
  showNotificaciones.value = false;
  if (notificacion.link) router.push(notificacion.link);
};

const marcarTodasLeidas = async () => {
  await api.patch("/notifications/read-all");
  notificaciones.value.forEach(n => { n.readAt = n.readAt || new Date().toISOString(); });
};

onMounted(cargarNotificaciones);
</script>
<template>
  <nav class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl"
    :class="isRTL ? 'top-0 position-sticky z-index-sticky' : ''" v-bind="$attrs" id="navbarBlur" data-scroll="true">
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :current-page="currentRouteName" :current-directory="currentDirectory" />

      <div class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4" :class="isRTL ? 'px-0' : 'me-sm-4'"
        id="navbar">
        <div class="pe-md-3 d-flex align-items-center" :class="isRTL ? 'me-md-auto' : 'ms-md-auto'">
          <div class="input-group">
            <span class="input-group-text text-body">
              <i class="fas fa-search" aria-hidden="true"></i>
            </span>
            <input type="text" class="form-control" :placeholder="isRTL ? 'أكتب هنا...' : 'Type here...'" />
          </div>
        </div>
        <ul class="navbar-nav justify-content-end">

          <li class="nav-item dropdown pe-3 d-flex align-items-center position-relative">
            <a
              href="#"
              class="p-0 nav-link"
              @click.prevent="toggleNotificaciones" style="color: white;"
            >
              <i class="bi bi-bell fs-5"></i>
              <span v-if="noLeidas > 0" class="badge bg-danger rounded-pill position-absolute" style="top: -4px; right: 4px; font-size: 0.6rem;">
                {{ noLeidas }}
              </span>
            </a>

            <ul
              class="dropdown-menu dropdown-menu-end px-2 py-2"
              :class="{ show: showNotificaciones }"
              style="width: 320px; max-height: 400px; overflow-y: auto; right: 0; left: auto;"
            >
              <li class="d-flex justify-content-between align-items-center px-2 pb-2 border-bottom">
                <strong class="small">Notificaciones</strong>
                <button class="btn btn-sm btn-link p-0" @click="marcarTodasLeidas">Marcar todas leídas</button>
              </li>
              <li v-if="notificaciones.length === 0" class="px-2 py-3 text-muted small text-center">
                Sin notificaciones.
              </li>
              <li v-for="n in notificaciones" :key="n.id">
                <a
                  href="#"
                  class="dropdown-item border-radius-md small"
                  :class="{ 'fw-bold': !n.readAt }"
                  @click.prevent="abrirNotificacion(n)"
                >
                  {{ n.message }}
                  <div class="text-muted" style="font-size: 0.7rem;">{{ formatFechaNoti(n.createdAt) }}</div>
                </a>
              </li>
            </ul>
          </li>

          <li class="nav-item ps-3 d-flex align-items-center">
            <a href="#" @click.prevent="minimizeSidebar" class="p-0 nav-link" id="iconNavbarSidenav">
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line bg-light"></i>
                <i class="sidenav-toggler-line bg-light"></i>
                <i class="sidenav-toggler-line bg-light"></i>
              </div>
            </a>
          </li>


        </ul>
      </div>
    </div>
  </nav>
</template>
